// extracted by mini-css-extract-plugin
module.exports = {"CARD_RATIO-card":".625","CARD_RATIO-square":"1","tagsContainer":"ProductTags_tagsContainer___5lLp","tag":"ProductTags_tag__A7_8H"};